import styled from 'styled-components';

export const ScrollTopWrapper = styled.div`
  position: fixed;
  background: transparent;
  bottom: 24px;
  z-index: 99;
  display: flex;
  flex-direction: column-reverse;
  gap: 2.5rem;
  font-family: ${(props) => props?.themeConfig?.buttonPrimary?.fontFamily};
  ::after {
    color: ${(props) => props?.themeConfig?.buttonPrimary?.color};
    background-color: ${(props) =>
      props?.themeConfig?.buttonPrimary?.backgroundHoverColor};
  }
  &.btn_scroll_cfe {
    right: ${(props) => (props?.styleConfig === 'right' ? '24px' : 'unset')};
    left: ${(props) => (props?.styleConfig === 'left' ? '24px' : 'unset')};
  }
  & > .scroll {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    outline: none;
    border: none;
    width: 3rem;
    height: 3rem;
    font-size: 3rem;
    padding: 0.75rem 1rem;
    color: ${(props) => props?.themeConfig?.buttonPrimary?.color};
    background-color: ${(props) => props?.themeConfig?.buttonPrimary?.backgroundColor};
    border-radius: ${(props) => props?.themeConfig?.buttonPrimary?.borderRadius};
    cursor: pointer;
  }
  @media screen and (min-width: 768px) {
    &.btn_scroll_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '400px' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      bottom: 80px;
    }
    &.btn_scroll_preview_desktop {
      right: ${(props) => (props?.styleConfig === 'right' ? '7%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      bottom: 48px;
    }
    &.btn_scroll_preview_mobile {
      right: ${(props) => (props?.styleConfig === 'right' ? '38.5%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      bottom: 48px;
    }
  }
  @media screen and (min-width: 1441px) {
    &.btn_scroll_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '400px' : 'unset')};
      bottom: 80px;
    }
  }
  @media screen and (max-width: 767px) {
    &.btn_scroll_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '400px' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '6.5%' : 'unset')};
      bottom: 80px;
    }
  }
`;
